import type { Metadata, PaginationParams } from '@/types';
import type { MyVotesData } from '../../types';

import { axiosClient } from '@/lib/axios';
import { QueryFunction, useQuery } from '@tanstack/react-query';

type ResponseData = {
  data: MyVotesData[];
  metadata: Metadata;
};

type Params = {
  companyID: number;
  meetingID: number;
  queryParams?: {
    sort_by?: keyof MyVotesData;
    sort_dir?: 'asc' | 'desc';
    q?: string;
  } & PaginationParams;
};

export const getMyVotes = async ({ companyID, meetingID, queryParams }: Params): Promise<ResponseData> => {
  const { data } = await axiosClient.get<ResponseData>(`/companies/${companyID}/meetings/${meetingID}/my-votes`, {
    params: queryParams,
  });
  return data;
};
type QueryFnType = typeof getMyVotes;

type UseGetMyVotesOptions = {
  companyID: number;
  meetingID: number;
  queryParams?: Params['queryParams'];
  config?: QueryFunction<QueryFnType>;
};

export const useGetMyVotes = ({ companyID, meetingID, queryParams, config }: UseGetMyVotesOptions) => {
  return useQuery({
    queryKey: ['meetings', companyID, meetingID, queryParams],
    queryFn: () => getMyVotes({ companyID, meetingID, queryParams }),
    ...config,
  });
};
